import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

/**
 * jyyb8AfJ PR 2 — admin reactivate-user confirm modal.
 *
 * Non-destructive treatment (UserCheck icon on success-coloured background)
 * because reactivation grants access. No "cannot be undone" copy — the
 * admin can simply deactivate again if it was a mistake.
 */
const ReactivateUserConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  isReactivating = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-5 w-full max-w-md">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="flex items-center justify-center w-12 h-12 bg-success/10 rounded-full flex-shrink-0">
              <Icon name="UserCheck" size={24} color="var(--color-success)" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-foreground mb-2">
                Reactivate {userName || 'this user'}?
              </h2>
              <p className="text-sm text-muted-foreground">
                They will be able to sign in again and resume their previous access. Their role and history are restored exactly as they were before deactivation.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-4 border-t border-border bg-muted/30">
          <Button variant="outline" onClick={onClose} disabled={isReactivating}>
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={onConfirm}
            disabled={isReactivating}
            iconName={isReactivating ? 'Loader2' : 'UserCheck'}
            iconPosition="left"
          >
            {isReactivating ? 'Reactivating…' : 'Reactivate'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReactivateUserConfirmModal;
